// extracted by mini-css-extract-plugin
module.exports = {"windowAiStudio":"idt-aistudiowindow_windowaistudio__bmycg","windowAiStudioContent":"idt-aistudiowindow_windowaistudiocontent__3mual"};